import { Link } from "react-router-dom";
import { Leaf, Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1A2F25] text-[#F9F6F0] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-full bg-[#D47C59] flex items-center justify-center">
              <Leaf className="w-5 h-5 text-white" strokeWidth={1.5} />
            </div>
            <span className="font-serif text-2xl font-medium">Backyard Buddy</span>
          </Link>
          <p className="text-[#E5E0D8] max-w-md font-light leading-relaxed">
            By Linda Godlewsky Ugi · 38+ years cultivating outdoor magic. Backyard Buddy turns
            your DIY dreams into doable, beautiful outdoor spaces — with a little AI help and
            a lot of heart.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" className="w-10 h-10 rounded-full border border-[#E5E0D8]/30 flex items-center justify-center hover:bg-[#D47C59] hover:border-[#D47C59] transition-all">
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-[#E5E0D8]/30 flex items-center justify-center hover:bg-[#D47C59] hover:border-[#D47C59] transition-all">
              <Facebook className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-[#E5E0D8]/30 flex items-center justify-center hover:bg-[#D47C59] hover:border-[#D47C59] transition-all">
              <Twitter className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div>
          <p className="overline mb-4 text-[#D47C59]">Explore</p>
          <ul className="space-y-2 text-sm font-light">
            <li><Link to="/gallery" className="hover:text-[#D47C59] transition-colors">Gallery</Link></li>
            <li><Link to="/ideas" className="hover:text-[#D47C59] transition-colors" data-testid="footer-ideas-link">Backyard Ideas</Link></li>
            <li><Link to="/wall" className="hover:text-[#D47C59] transition-colors" data-testid="footer-wall-link">Backyard Wall</Link></li>
            <li><Link to="/ai-designer" className="hover:text-[#D47C59] transition-colors">AI Designer</Link></li>
            <li><Link to="/plants" className="hover:text-[#D47C59] transition-colors">Plant Library</Link></li>
            <li><Link to="/projects" className="hover:text-[#D47C59] transition-colors">Project Planner</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4 text-[#D47C59]">Find it locally</p>
          <ul className="space-y-2 text-sm font-light">
            <li><Link to="/find-plants-near-me" className="hover:text-[#D47C59] transition-colors" data-testid="footer-find-plants-link">Plants Near Me</Link></li>
            <li><Link to="/local-garden-centers" className="hover:text-[#D47C59] transition-colors">Garden Centers</Link></li>
            <li><Link to="/plant-nurseries-near-me" className="hover:text-[#D47C59] transition-colors">Plant Nurseries</Link></li>
            <li><Link to="/landscape-materials-near-me" className="hover:text-[#D47C59] transition-colors">Landscape Materials</Link></li>
            <li><Link to="/landscape-suppliers-near-me" className="hover:text-[#D47C59] transition-colors">Landscape Suppliers</Link></li>
            <li><Link to="/mulch-near-me" className="hover:text-[#D47C59] transition-colors" data-testid="footer-mulch-link">Mulch Near Me</Link></li>
            <li><Link to="/topsoil-near-me" className="hover:text-[#D47C59] transition-colors">Topsoil Near Me</Link></li>
            <li><Link to="/stone-gravel-near-me" className="hover:text-[#D47C59] transition-colors">Stone &amp; Gravel</Link></li>
            <li><Link to="/paver-suppliers-near-me" className="hover:text-[#D47C59] transition-colors">Paver Suppliers</Link></li>
            <li><Link to="/landscaping-ideas" className="hover:text-[#D47C59] transition-colors" data-testid="footer-towns-link">NJ Ideas by Town</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4 text-[#D47C59]">Company</p>
          <ul className="space-y-2 text-sm font-light">
            <li><Link to="/about" className="hover:text-[#D47C59] transition-colors">About</Link></li>
            <li><Link to="/academy" className="hover:text-[#D47C59] transition-colors" data-testid="footer-academy-link">Landscape Academy</Link></li>
            <li><Link to="/blog" className="hover:text-[#D47C59] transition-colors">Blog</Link></li>
            <li><Link to="/pricing" className="hover:text-[#D47C59] transition-colors">Pricing</Link></li>
            <li><Link to="/privacy" className="hover:text-[#D47C59] transition-colors">Privacy</Link></li>
            <li><a href="mailto:hello@backyardbuddy.com" className="hover:text-[#D47C59] transition-colors">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E0D8]/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#E5E0D8]/70 font-light">
          <p>&copy; {new Date().getFullYear()} Backyard Buddy · Created by Linda Godlewsky Ugi.</p>
          <p>38 years of dirt-stained passion, packed into an app.</p>
        </div>
      </div>
    </footer>
  );
}
